import React, { useContext } from "react";
import style from "./Navsetting.module.css";
import {LuSettings} from "react-icons/lu"
import {PiChatsCircle} from "react-icons/pi"
import {MdWbTwilight,MdAddComment, MdLogout} from "react-icons/md"
import {BsPersonAdd} from "react-icons/bs"
import {NavLink} from "react-router-dom"
import { signOut } from "firebase/auth";
import { auth } from "../../firebase/config";
import {useNavigate } from "react-router-dom";
import { Chatcontext } from "../context/Chatcontext";
import { BiSolidMessageSquareEdit } from "react-icons/bi";

const Navsetting=()=>{
    const navigate = useNavigate();
    const chatcontext=useContext(Chatcontext)
    const logoutUser = () => {
        chatcontext.changechat("null")
        signOut(auth)
          .then(() => {
            navigate("/");
        })
    };
    return(
        <div className={style.settingbar}>
            <div className={style.icon}>
                <MdLogout onClick={logoutUser} style={{cursor:"pointer"}} size={35}/>
                <LuSettings size={35}/>
            </div>
            <NavLink to="adminchats" className={({isActive})=>( isActive ? style.active : "")}>المجموعات<PiChatsCircle size={48}/></NavLink>
            <NavLink to="adminpermission" className={({isActive})=>( isActive ? style.active : "")}>الاذونات<MdWbTwilight size={48}/></NavLink>
            <NavLink to="createchat" className={({isActive})=>( isActive ? style.active : "")}>اضافه مجموعه <MdAddComment size={48}/></NavLink>
            <NavLink to="adduser" className={({isActive})=>( isActive ? style.active : "")}>اضافه شخص<BsPersonAdd size={48}/></NavLink>  
            <NavLink to="finishedchats" className={({isActive})=>( isActive ? style.active : "")}>مجموعات تم الانتهاء منها<PiChatsCircle size={48}/></NavLink>
            <NavLink to="editeusers" className={({isActive})=>( isActive ? style.active : "")}> التعديل علي بيانات العملاء  <BiSolidMessageSquareEdit size={48}/></NavLink>

        </div>
    )
}
export default Navsetting;